// extracted by mini-css-extract-plugin
export default {"kcbPrivacy":"kcbPrivacy_kcbPrivacy__rcebE"};